module["exports"] = [
  "ТОВ",
  "ПАТ",
  "ПрАТ",
  "ТДВ",
  "КТ",
  "ПТ",
  "ДП",
  "ФОП"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/company/prefix.js
// module id = 1673
// module chunks = 0